export const COUNTRY_CODE_US = 'US';
export const COUNTRY_CODE_CA = 'CA';
export const COUNTRY_CODE_MX = 'MX';

export enum StateEnum {
  AL = 'Alabama',
  AK = 'Alaska',
  AZ = 'Arizona',
  AR = 'Arkansas',
  CA = 'California',
  CO = 'Colorado',
  CT = 'Connecticut',
  DE = 'Delaware',
  DC = 'District Of Columbia',
  FL = 'Florida',
  GA = 'Georgia',
  HI = 'Hawaii',
  ID = 'Idaho',
  IL = 'Illinois',
  IN = 'Indiana',
  IA = 'Iowa',
  KS = 'Kansas',
  KY = 'Kentucky',
  LA = 'Louisiana',
  ME = 'Maine',
  MD = 'Maryland',
  MA = 'Massachusetts',
  MI = 'Michigan',
  MN = 'Minnesota',
  MS = 'Mississippi',
  MO = 'Missouri',
  MT = 'Montana',
  NE = 'Nebraska',
  NV = 'Nevada',
  NH = 'New Hampshire',
  NJ = 'New Jersey',
  NM = 'New Mexico',
  NY = 'New York',
  NC = 'North Carolina',
  ND = 'North Dakota',
  OH = 'Ohio',
  OK = 'Oklahoma',
  OR = 'Oregon',
  PA = 'Pennsylvania',
  RI = 'Rhode Island',
  SC = 'South Carolina',
  SD = 'South Dakota',
  TN = 'Tennessee',
  TX = 'Texas',
  UT = 'Utah',
  VT = 'Vermont',
  VA = 'Virginia',
  WA = 'Washington',
  WV = 'West Virginia',
  WI = 'Wisconsin',
  WY = 'Wyoming',
  AA = 'AA (Armed Forces Americas)',
  AE = 'AE (Armed Forces Europe)',
  AP = 'AP (Armed Forces Pacific)',
  AS = 'American Samoa',
  FM = 'Fed St. Of Micronesia',
  GU = 'Guam',
  MH = 'Marshall Islands',
  MP = 'Northern Mariana Islands',
  PW = 'Palau',
  PR = 'Puerto Rico',
  TT = 'US Trust Territories',
  VI = 'Virgin Islands',
}

export enum CountryEnum {
  AF = 'Afghanistan',
  AX = 'Aland Islands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua and Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BQ = 'Bonaire, Saint Eustatius and Saba ',
  BA = 'Bosnia and Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet Island',
  BR = 'Brazil',
  IO = 'British Indian Ocean Territory',
  VG = 'Virgin Islands (British)',
  BN = 'Brunei Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina Faso',
  BI = 'Burundi',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  IC = 'Canary Islands',
  CV = 'Cape Verde',
  KY = 'Cayman Islands',
  CF = 'Central African Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas Island',
  CC = 'Cocos (Keeling) Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CD = 'Congo, Democratic Republic of',
  CG = 'Congo, Republic of',
  CK = 'Cook Islands',
  CR = 'Costa Rica',
  CI = "Cote d'Ivoire",
  HR = 'Croatia',
  CU = 'Cuba',
  EA = 'Ceuta and Melilla',
  CW = 'Curaçao',
  CY = 'Cyprus',
  CZ = 'Czech Republic',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican Republic',
  TL = 'East Timor',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El Salvador',
  GQ = 'Equatorial Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  ET = 'Ethiopia',
  FK = 'Falkland Islands',
  FO = 'Faroe Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French Guiana',
  PF = 'French Polynesia',
  TF = 'French Southern Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea-Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard and McDonald Islands',
  HN = 'Honduras',
  HK = 'Hong Kong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran (Islamic Republic of)',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle of Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KP = "Korea, Democratic People's Republic",
  KR = 'Korea, Republic of',
  XK = 'Kosovo',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = "Lao People's Democratic Republic",
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macau',
  MK = 'Macedonia',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia, Federal State of',
  MD = 'Moldova, Republic of',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar (Burma)',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  AN = 'Netherlands Antilles (Deprecated)',
  NC = 'New Caledonia',
  NZ = 'New Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk Island',
  MP = 'Northern Mariana Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PA = 'Panama',
  PG = 'Papua New Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn Island',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto Rico',
  QA = 'Qatar',
  RE = 'Reunion Island',
  RO = 'Romania',
  RU = 'Russian Federation',
  RW = 'Rwanda',
  BL = 'Saint Barthélemy',
  SH = 'Saint Helena',
  KN = 'Saint Kitts and Nevis',
  LC = 'Saint Lucia',
  MF = 'Saint Martin',
  VC = 'Saint Vincent and the Grenadines',
  WS = 'Samoa',
  SM = 'San Marino',
  ST = 'Sao Tome and Principe',
  SA = 'Saudi Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  CS = 'Serbia and Montenegro (Deprecated)',
  SC = 'Seychelles',
  SL = 'Sierra Leone',
  SG = 'Singapore',
  SX = 'Sint Maarten',
  SK = 'Slovak Republic',
  SI = 'Slovenia',
  SB = 'Solomon Islands',
  SO = 'Somalia',
  ZA = 'South Africa',
  GS = 'South Georgia',
  SS = 'South Sudan',
  ES = 'Spain',
  LK = 'Sri Lanka',
  PM = 'St. Pierre and Miquelon',
  PS = 'State of Palestine',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard and Jan Mayen Islands',
  SZ = 'Swaziland',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syrian Arab Republic',
  TW = 'Taiwan',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad and Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks and Caicos Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United Arab Emirates',
  GB = 'United Kingdom',
  US = 'United States',
  UM = 'US Minor Outlying Islands',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Vietnam',
  VI = 'Virgin Islands (USA)',
  WF = 'Wallis and Futuna',
  EH = 'Western Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabwe',
}

export type CountryCode = keyof typeof CountryEnum;

// Mapping countries
export const countryCodes: CountryCode[] = Object.keys(
  CountryEnum,
) as CountryCode[];
// Schema generator does not like Object.values()...
// export const countryNames: string[] = Object.values(CountryEnum);
export const countryNames: string[] = countryCodes.map(
  (code) => CountryEnum[code],
);
export const mapCountryNameToCode = (countryName: string) => {
  if (countryName?.length == 2) {
    const countryCode = countryName.toUpperCase() as CountryCode;
    if (countryCodes.includes(countryCode)) {
      // Already a country code
      return countryCode;
    }
  }
  // Could use content settings to get countries, but using the enum for now
  const countryIndex = countryNames.indexOf(countryName);
  return countryCodes[countryIndex] ?? COUNTRY_CODE_US;
};
export const mapCountryCodeToName = (countryCode: CountryCode) => {
  const countryIndex = countryCodes.indexOf(countryCode);
  return countryNames[countryIndex] ?? COUNTRY_CODE_US;
};

export const countryToIso = (
  country?: string | null | undefined,
  localId?: string,
) => {
  const countryKey = country || localId?.slice(0, 2);
  switch (countryKey) {
    case 'Bangladesh':
    case 'BD': {
      return 'BD';
    }
    case 'Bolivia':
    case 'BO': {
      return 'BO';
    }
    case 'Brazil':
    case 'BR': {
      return 'BR';
    }
    case 'Burkina Faso':
    case 'BF': {
      return 'BF';
    }
    case 'Cambodia':
    case 'KH': {
      return 'KH';
    }
    case 'Colombia':
    case 'CO': {
      return 'CO';
    }
    case 'Dominican Republic':
    case 'DO':
    case 'DR': {
      return 'DO';
    }
    case 'Ecuador':
    case 'EC': {
      return 'EC';
    }
    case 'El Salvador':
    case 'SV':
    case 'ES': {
      return 'SV';
    }
    case 'Ethiopia':
    case 'ET': {
      return 'ET';
    }
    case 'Ghana':
    case 'GH': {
      return 'GH';
    }
    case 'Guatemala':
    case 'GT':
    case 'GU': {
      return 'GT';
    }
    case 'Haiti':
    case 'HT':
    case 'HA': {
      return 'HT';
    }
    case 'Honduras':
    case 'HN':
    case 'HO': {
      return 'HN';
    }
    case 'Indonesia':
    case 'East Indonesia':
    case 'ID':
    case 'IO': {
      return 'ID';
    }
    case 'Kenya':
    case 'KE': {
      return 'KE';
    }
    case 'Malawi':
    case 'MW': {
      return 'MW';
    }
    case 'Myanmar':
    case 'MM': {
      return 'MM';
    }
    case 'Mexico':
    case 'ME':
    case 'MX': {
      return 'MX';
    }
    case 'Nicaragua':
    case 'NI': {
      return 'NI';
    }
    case 'Peru':
    case 'PE': {
      return 'PE';
    }
    case 'Philippines':
    case 'PH': {
      return 'PH';
    }
    case 'Rwanda':
    case 'RW': {
      return 'RW';
    }
    case 'Sri Lanka':
    case 'LK': {
      return 'LK';
    }
    case 'Tanzania':
    case 'TZ': {
      return 'TZ';
    }
    case 'Thailand':
    case 'TH': {
      return 'TH';
    }
    case 'Togo':
    case 'TG': {
      return 'TG';
    }
    case 'Uganda':
    case 'UG': {
      return 'UG';
    }
    case 'Zambia':
    case 'ZM': {
      return 'ZM';
    }
    default: {
      return '';
    }
  }
};
